import textures from './img/colors/textures.jpg'
import errorBKG from './img/error/error.jpg'
import error404BKG from './img/error/error-404.jpg'
import errorInactiveCampaign from './img/error/error-inactive.jpg'
import certificate from './img/certificate/certificate.png'

const img = {
  textures,
  errorBKG,
  error404BKG,
  errorInactiveCampaign,
  certificate
}

export default img
